import { render, staticRenderFns } from "./DetalhesParticipantes.vue?vue&type=template&id=12ca7817&scoped=true"
import script from "./DetalhesParticipantes.vue?vue&type=script&lang=ts"
export * from "./DetalhesParticipantes.vue?vue&type=script&lang=ts"
import style1 from "./DetalhesParticipantes.vue?vue&type=style&index=1&id=12ca7817&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ca7817",
  null
  
)

export default component.exports